import React, { useEffect, useState } from "react";
import axios from "axios";
import { Photo } from "@mui/icons-material";
import { Box, Typography, Link } from "@mui/material";
import { styled } from "@mui/material/styles";

function FilePreview({ filePath, altText = "" }) {
  const [blobUrl, setBlobUrl] = useState("");
  const [fileType, setFileType] = useState("");
  const [error, setError] = useState(null);

  const baseUrl = process.env.REACT_APP_BASE_URL;

  let fullUrl = filePath?.trim() || "";
  if (fullUrl.startsWith("/")) {
    fullUrl = baseUrl + fullUrl;
  }

  useEffect(() => {
    setBlobUrl("");
    setFileType("");
    setError(null);

    if (!filePath) return;

    const fetchFile = async () => {
      try {
        const token = localStorage.getItem("d4uToken");
        const response = await axios.get(fullUrl, {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "blob",
        });


        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });


        const newBlobUrl = URL.createObjectURL(blob);

        setBlobUrl(newBlobUrl);
        setFileType(blob.type || "");
      } catch (err) {
        console.error("File fetch failed:", err);
        setError(err);
      }
    };

    fetchFile();

    return () => {
      if (blobUrl) {
        URL.revokeObjectURL(blobUrl);
      }
    };
  }, [filePath]);

  if (!filePath) {
    return (
      <NoDocumentContainer>
        <StyledPhoto />
        <Typography variant="h6">No file available</Typography>
      </NoDocumentContainer>
    );
  }

  if (error) {
    return (
      <NoDocumentContainer>
        <StyledPhoto />
        <Typography variant="h6">Failed to load file</Typography>
        <StyledLink href={fullUrl} target="_blank" rel="noreferrer">
          Try opening directly
        </StyledLink>
      </NoDocumentContainer>
    );
  }

  if (!blobUrl) {
    return <Typography>Loading preview...</Typography>;;
  }

  const extension = filePath.split(".").pop().toLowerCase();
  const isImage =
    fileType.startsWith("image/") ||
    ["jpg", "jpeg", "png", "gif"].includes(extension);
  const isPdf =
    fileType === "application/pdf" ||
    extension === "pdf";

  if (isImage) {
    return (
      <img
        className="vimg img-fluid"
        src={blobUrl}
        alt={altText}
        style={{ maxWidth: "300px", maxHeight: "300px" }}
      />
    );
  }

  if (isPdf) {
    return (
      <iframe
        src={blobUrl}
        title="PDF Preview"
        width="400px"
        height="500px"
        style={{ border: "none" }}
      />
    );
    /*
    return (
      <embed
        src={blobUrl}
        type="application/pdf"
        width="400px"
        height="500px"
      />
    );
    */
  }

  return (
    <NoDocumentContainer>
      <StyledPhoto />
      <Typography variant="h6">Preview not available for this file type.</Typography>
      <StyledLink href={blobUrl} target="_blank" rel="noreferrer">
        Open file
      </StyledLink>
    </NoDocumentContainer>
  );
}


// Styled Box for no-document
const NoDocumentContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "20px",
  border: `2px dashed ${theme.palette.grey[400]}`,
  borderRadius: "8px",
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.text.secondary,
  textAlign: "center",
  maxWidth: "300px",
  margin: "0 auto",
}));

const StyledPhoto = styled(Photo)(({ theme }) => ({
  fontSize: "100px",
  marginBottom: theme.spacing(2),
  color: theme.palette.grey[500],
}));


const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.primary.main,
  textDecoration: "none",
  fontWeight: "bold",
  marginTop: theme.spacing(1),
  '&:hover': {
    textDecoration: "underline",
  },
}));


export default FilePreview;
